import z from "zod";
import { CriterioAvaliacaoFornecedorSchema } from "./criterio_avaliacao_fornecedor";

/**
 * AvaliacaoFornecedorSchema
 */

export const AvaliacaoFornecedorSchema = z.object({
  fornecedores: z.array(z.number()),
  avaliadoPor: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  data: z.coerce.date({ required_error: 'Este campo deve ser preenchido!' }),
  centroCusto: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  nroNotaFiscal: z.string().nonempty('Este campo deve ser preenchido!'),
  criteriosAvaliacaoFornecedor: z.array(CriterioAvaliacaoFornecedorSchema),
  observacao: z.string().default(""),
});

/**
 * AvaliacaoFornecedorForm
 */

export type AvaliacaoFornecedorForm = z.infer<typeof AvaliacaoFornecedorSchema>; 